import React, { useState, useEffect, useRef } from "react";
import "./style.css";

/**
   @function BecomePartner - функциональный компонент, представляющий блок формы для отправки заявки агенту. 
   Позволяет заполнить данные, отправить заявку и отображает блоки с уведомлениями об отправке данных.
*/
function BecomePartner()
{
    //Переменные, которые требуется отслеживать с помощью хуков состояния
    const [fullName,            setFullName]            = useState('');
    const [PhoneNum,            setPhoneNum]            = useState('');
    const [isButtonDisabled,    setIsButtonDisabled]    = useState(true);
    const [isFormOpen,          setIsFormOpen]          = useState(false);
    const [isOpenDowBlock,      setIsOpenDowBlock]      = useState(false);
    const [isOpenGoodSendBlock, setIsOpenGoodSendBlock] = useState(false);
    const [isOpenBadSendBlock,  setIsOpenBadSendBlock]  = useState(false);
    const [errorbool,           setErrorbool]           = useState(false);
    const [resp, setResp]                               = useState(false);

    const chatId = -4140966779; // 797596124 - Kirill, 1448729978 - Evgeni, 2122883046 - Valeri, -4140966779 - chat

    //Функция открытия формы для заполнения имени(возможно автоматически) и номера телефона(вручную)
    function openForm()
    {
        setIsFormOpen(true);
    }

    //Функция закрытия формы, описанной выше
    function closeForm()
    {
        setIsFormOpen(false);
    }

    //Функция открытия формы с отправкой данных, чтобы запрос успел обработаться и вернуть результат отправки(успешный/провальный)
    function openDowBlock()
    {
        setIsOpenDowBlock(true);
    }

    //Функция закрытия формы, описанной выше
    function closeDowBlock()
    {
        setIsOpenDowBlock(false);
    }

    //Функция открытия формы с проваленной отправкой данных
    function openBadSendBlock()
    {
        setIsOpenBadSendBlock(true);
    }

    //Функция закрытия формы, описанной выше
    function closeBadSendBlock()
    {
        setIsOpenBadSendBlock(false);
    }

    //Функция открытия формы с проваленной отправкой данных
    function openGoodSendBlock()
    {
        setIsOpenGoodSendBlock(true);
    }

    //Функция закрытия формы, описанной выше
    function closeGoodSendBlock()
    {
        setIsOpenGoodSendBlock(false);
    }

    //Функции проверки полей ввода в форме(ФИО/Телефон). Работает так, что пока поля не заполнены, кнопка будет неактивна и подсвечиваться серым цветом, а при вводе хотя бы
    //каких-то данных в оба поля кнопка будет активироваться и подсвечиваться градиентом
    const handleFullNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newFullName = event.target.value;
        setFullName(newFullName);
        updateButtonState(newFullName, PhoneNum);
    }

    const handlePhoneNumChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newPhoneNum = event.target.value;
        setPhoneNum(newPhoneNum);
        updateButtonState(fullName, newPhoneNum);
    }

    const updateButtonState = (newFullName: string, newPhoneNum: string) => {
        if (newFullName.trim() !== "" && newPhoneNum.trim() !== "") {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    }

    //Функция отправки изначальной формы, активирующая цепочку открытия соответствующих форм. Изначально будет идти форма отправки данных, пока запрос обрабатывается.
    //После чего уже откроется форма в соответствии с ответом запроса. Если всё успешно, то на chatId в Телеграм отправляется соответствующая строка message.
    const submitForm = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        var message = `URL: ${document.URL}\n\n ФИО: ${fullName}\n Номер телефона: ${PhoneNum}`;
        sendMessage(chatId, message, errorbool);
        closeForm();
        openDowBlock();

        setTimeout(() =>
        {
            closeDowBlock();

            if ( errorbool)
            {
                openBadSendBlock();
            }
            else
            {
                openGoodSendBlock();
            }
        }, 3000);
    }

    //Функция отправки запроса, содержащего данные из формы и ссылку на страницу, откуда отправлен запрос, на телеграм с определенным chatId. Осуществляется запрос через fetch
    const sendMessage = (chatId: number, text: string, errorbool: boolean) =>
    {
        const url = 'https://api.telegram.org/bot7064703080:AAGVqAkyT6-Gy1Y-dMEf0XPM23Ci1lkvx88/sendMessage';
        const params =
        {
            chat_id: chatId,
            text: text
        };

        fetch(url,
        {
            method: 'POST', //Запрос через метод POST для шифрования данных
            headers:
            {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        })
            .then(response => response.json())
            .then(data =>
            {
                setResp(data);
            })
            .catch(error =>
            {
                setErrorbool(true);
            });
    };

    return (
        <React.Fragment>

            <div className="justify-content-center">
                <button className="sales-btn width1875" onClick={openForm} style={{ border: 'none' }}>
                    <span>Стать партнером</span>
                </button>
            </div>

                <div className="container-login100">
                    <div id="form" className="wrap-login100" style={{ display: isFormOpen ? 'block' : 'none' }}>
                        <form className="login100-form validate-form p-l-55 p-r-55 p-t-178">
                            <span className="login100-form-title">
                                <span className="login100-form-title-text">Услуги агента</span>
                            <button className="closeBtn" type="button" id="close" onClick={closeForm}><img style={{ padding: '1px', background: '#fff' }} src="../../../ReactComponents/BecomePartner/close.svg" /></button>
                            </span>
                            <span className="formHeader">Заполните форму</span>
                            <div className="wrap-input100 validate-input m-b-16">
                                <input className="input100" type="text" id="name" placeholder="Имя" value={fullName} onChange={handleFullNameChange} />
                                <span className="focus-input100"></span>
                            </div>

                            <div className="wrap-input100 validate-input">
                                <input className="input100" type="tel" id="phone" placeholder="Телефон" value={PhoneNum} onChange={handlePhoneNumChange} />
                                <span className="focus-input100"></span>
                            </div>

                            <div className="container-login100-form-btn">
                            <button className="sendBut login100-form-btn" style={{background: isButtonDisabled ? '#B7B6BB' : 'linear-gradient(229.99deg, #BA38FF -2.16%, #AF2EFF 16.16%, #9E00FF 51.38%, #5532FF 71.26%, #5431FF 79.66%, #5430FF 93.81%)'}} id="submit" onClick={submitForm} disabled={isButtonDisabled}>Отправить заявку</button>
                            </div>
                        </form>
                    </div>

                    <div id="OpenDowBlock" className="wrap-login100w" style={{ display: isOpenDowBlock ? 'block' : 'none' }}>
                        <form className="login100-formw validate-form p-l-55 p-r-55 p-t-178">
                        <span className="login100-form-titlew">
                            <button className="closeBtnw" type="button" id="close" onClick={closeDowBlock}>
                                <img style={{ padding: '1px', background: '#fff' }} src="../../../ReactComponents/BecomePartner/close.svg"/>
                            </button>
                        </span>
                            <span className="formHeaderw">Данные обрабатываются ...</span>
                            <section className="dots-container">
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                            </section>
                        </form>
                    </div>

                    <div id="BadSendBlock" className="wrap-login100w_r" style={{ display: isOpenBadSendBlock ? 'block' : 'none' }}>
                        <form className="login100-formw_r validate-form p-l-55 p-r-55 p-t-178">
                        <span className="login100-form-titlew_r">
                            <button className="closeBtnw_r" type="button" id="close" onClick={closeBadSendBlock}><img style={{ padding: '1px', background: '#fff' }} src="../../../ReactComponents/BecomePartner/close.svg" /></button>
                        </span>
                            <div className="ErrorBlock">
                                <span className="formHeaderw_r">Ошибка!</span>
                                <span className="dir_err_r">Что-то пошло не так, попробуйте отправить заявку еще раз!</span>
                            </div>
                        </form>
                    </div>

                    <div id="GoodSendBlock" className="wrap-login100w_g" style={{ display: isOpenGoodSendBlock ? 'block' : 'none' }}>
                        <form className="login100-formw_g validate-form p-l-55 p-r-55 p-t-178">
                            <span className="login100-form-titlew_g">
                                <button className="closeBtnw_g" type="button" id="close" onClick={closeGoodSendBlock}><img style={{ padding: '1px', background: '#fff' }} src="../../../ReactComponents/BecomePartner/close.svg"/></button>
                            </span>
                            <div className="GoodBlock">
                                <span className="formHeaderw_g">Данные успешно отправлены</span>
                                <span className="dir_good">Ваша заявка на помощь агента успешно отправлена. В ближайшее время мы с вами свяжемся!</span>
                            </div>
                            <div className="container-login100-form-btn_g">
                                <button className="sendBut_g login100-form-btn_g" onClick={closeGoodSendBlock} type="button">Ок</button>
                            </div>
                        </form>
                    </div>
                </div>
        </React.Fragment>
        
    );
}
export { BecomePartner };